import { useState } from 'react'
import { generatePath, Redirect, useHistory } from 'react-router-dom'

import { useModals } from 'almanac-ui/Modal'

import { NewPaywallModal } from 'components/Paywall/NewPaywallModal/NewPaywallModal'

import { useAuth } from 'hooks/UseAuth'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useFetchWorkspaces } from 'hooks/useFetchWorkspaces'

import { BLAZE_HOME_PATH, LOGIN_PATH } from 'paths'
import queryClient from 'queryClient'
import { useRootStore } from 'stores/RootStore'
import { ALMANAC_CORE_WORKSPACE_ID } from 'utils/constants'
import { UserService } from 'api/clients/UserService'

export const Paywall = () => {
  const [hasOpenedModal, setHasOpenedModal] = useState(false)

  const { openModal, closeAllModals } = useModals()
  const auth = useAuth()
  const workspace = useCurrentWorkspace()
  const history = useHistory()
  const featureFlags = useRootStore().featureFlags

  useFetchWorkspaces()

  if (!auth) {
    return <Redirect to={LOGIN_PATH} />
  }

  if (!workspace || workspace.id === ALMANAC_CORE_WORKSPACE_ID) {
    return null
  }

  const workspaceHomePath = generatePath(BLAZE_HOME_PATH, { workspaceId: workspace.id })

  if (workspace.paying || workspace.is_virtual_marketer) {
    return <Redirect to={workspaceHomePath} />
  }

  if (hasOpenedModal) {
    return null
  }

  openModal(
    NewPaywallModal,
    {
      logoutOverride: () => {
        UserService.unsetAuthCookie()
        featureFlags.clear()
        queryClient.invalidateQueries('featureFlags')
        history.push(LOGIN_PATH)
        closeAllModals()
      },
    },
    { underlayVariant: 'robot' },
  )

  setHasOpenedModal(true)

  return null
}
